import z from 'zod';

export const JobSearchVMSchema = z.object({
	id: z.string(),

	companyDescription: z.string().nullable(),
	companyName:        z.string(),
	description:        z.string().nullable(),
	detailUrl:          z.string().url(),
	eligibility:        z.string().nullable(),
	endDate:            z.date().nullable(),
	entryUrl: 	         z.string().url(),
	hasApplied:         z.boolean().default(false),
	hasSaved:           z.boolean().default(false),
	location: 	         z.string(),
	startDate:          z.date().nullable(),
	summary:            z.string(),
	title:              z.string(),
	workHours:          z.string().nullable(),

	coverImage: z.object({
		caption: z.string().nullable(),
		url:     z.string().url().nullable(),
	}),
	salary: z.object({
		max: z.number(),
		min: z.number(),
	}),
});
export type JobSearchVM = z.infer<typeof JobSearchVMSchema>;
